module.exports = __webpack_public_path__ + "img/reels.414c396d.jpg";